/**
 * Maps MultiSelect values for "Program / Level" filters (e.g. "3.1 1") into
 * GraphQL `universityStudents` filter fields.
 */
export type ProgramLevelFilterGraphQLInput = {
  curriculumVersions: string[] | undefined;
  levels: number[] | undefined;
};

export function parseProgramLevelFilterSelections(selectedPrograms: string[]): ProgramLevelFilterGraphQLInput {
  const curriculumVersions: string[] = [];
  const levels: number[] = [];

  selectedPrograms.forEach((program) => {
    const [version, levelStr] = program.split(" ");

    if (!curriculumVersions.includes(version)) {
      curriculumVersions.push(version);
    }

    if (levelStr !== "Complete" && !isNaN(Number(levelStr))) {
      const level = Number(levelStr);
      if (!levels.includes(level)) {
        levels.push(level);
      }
    }
  });

  return {
    curriculumVersions: curriculumVersions.length > 0 ? curriculumVersions : undefined,
    levels: levels.length > 0 ? levels : undefined
  };
}
